<div class="container-fluid">
  <h1 class="title">{{(categoriaHijo || categoriaPadre) ? (categoriaHijo ? (categoriaHijo + ', ' + categoriaHijo + ' al por mayor') : (categoriaPadre + ', ' + categoriaPadre + ' al por mayor')) : 'Productos de ' + familiaActual + ' por mayor, fabrica de productos de ' + familiaActual}}</h1>
</div>
<div class="row message">
  <div class="container-fluid">
    <ngb-alert *ngIf="successMessage" (click)="alertClicked()" type="success" (close)="alertClicked()">
      <i class="fa fa-check-circle fa-3x" aria-hidden="true"></i>
      {{ successMessage }}
      <button type="button" class="actionButton transparentButton" [routerLink]="['/compra/carrito']">VER TODOS</button>
    </ngb-alert>
    <ngb-alert *ngIf="successFavoritoMessage && clientOnlyRun" (click)="alertFavoritoClicked()" type="success" (close)="alertFavoritoClicked()">
      <i class="fa fa-check-circle fa-3x" aria-hidden="true"></i>
      {{ successFavoritoMessage }}
      <button type="button" class="actionButton transparentButton" [routerLink]="['/cuenta']" [queryParams]="{tab: '2'}">VER TODOS</button>
    </ngb-alert>
  </div>
</div>
<div class="container filter">
  <div class="row">
    <div class="col-lg-2  d-none d-md-none d-lg-block">
      <div class="containerSidebarCategorias">
        <div class="filter__top vista" style="display: flex; align-items: center; justify-content: space-between;">
          <p style="margin-bottom: 0;">Vista</p>
                        <i (click)="toggleVistaSidebar()" class="fa" [ngClass]="{'fa-chevron-down': !showVistaSidebar, 'fa-chevron-up': showVistaSidebar}" style="cursor: pointer; transition: transform 0.3s ease;"></i>
        </div>
        <div class="row listadoCategorias collapse-content" [ngClass]="{'open': showVistaSidebar}">
          <p *ngIf="modoVista === 'Listado'" style="margin-left: 20px; cursor: pointer;" (click)="cambiarVista('Listado')"><strong>Ver todos</strong></p>
          <p *ngIf="modoVista !== 'Listado'" style="margin-left: 20px; cursor: pointer;" (click)="cambiarVista('Listado')">Ver todos</p>
          <p *ngIf="modoVista === 'Paginado'" style="margin-left: 20px; cursor: pointer;" (click)="cambiarVista('Paginado')"><strong>Paginado</strong></p>
          <p *ngIf="modoVista !== 'Paginado'" style="margin-left: 20px; cursor: pointer;" (click)="cambiarVista('Paginado')">Paginado</p>
        </div>
      </div>
      <div class="containerSidebarCategorias">
        <div class="filter__top" style="display: flex; align-items: center; justify-content: space-between;">
          <p style="margin-bottom: 0;">Ordenar productos</p>
                        <i (click)="toggleOrdenarSidebar()" class="fa" [ngClass]="{'fa-chevron-down': !showOrdenarSidebar, 'fa-chevron-up': showOrdenarSidebar}" style="cursor: pointer; transition: transform 0.3s ease;"></i>
        </div>
        <div class="row listadoCategorias collapse-content" [ngClass]="{'open': showOrdenarSidebar}">
          <p *ngIf="!ordenamiento || (!ordenamiento.startsWith('nombre') && !ordenamiento.startsWith('precio'))" style="margin-left: 20px; cursor: pointer;" (click)="ordenPorDefecto()"><strong>Por defecto</strong></p>
          <p *ngIf="ordenamiento && (ordenamiento.startsWith('nombre') || ordenamiento.startsWith('precio'))" style="margin-left: 20px; cursor: pointer;" (click)="ordenPorDefecto()">Por defecto</p>
          <p *ngIf="ordenamiento && ordenamiento.startsWith('nombre')" style="margin-left: 20px; cursor: pointer;" (click)="ordenPorNombre()"><strong>Nombre</strong></p>
          <p *ngIf="!ordenamiento || !ordenamiento.startsWith('nombre')" style="margin-left: 20px; cursor: pointer;" (click)="ordenPorNombre()">Nombre</p>
          <p *ngIf="ordenamiento && ordenamiento.startsWith('precio') && loginStatus" style="margin-left: 20px; cursor: pointer;" (click)="ordenPorPrecio()"><strong>Precio</strong></p>
          <p *ngIf="(!ordenamiento && loginStatus) || (!ordenamiento.startsWith('precio') && loginStatus)" style="margin-left: 20px; cursor: pointer;" (click)="ordenPorPrecio()">Precio</p>
        </div>
      </div>
      <div class="containerSidebarCategorias">
        <div class="filter__top" style="display: flex; align-items: center; justify-content: space-between;">
          <p style="margin-bottom: 0;">Categorias</p>
          <i (click)="toggleCategoriasSidebar()" class="fa" [ngClass]="{'fa-chevron-down': !showCategoriasSidebar, 'fa-chevron-up': showCategoriasSidebar}" style="cursor: pointer; transition: transform 0.3s ease;"></i>
        </div>
        <div class="listadoCategorias collapse-content" [ngClass]="{'open': showCategoriasSidebar}">
          <div class="listadoCategorias" *ngFor="let cat of id_categoria">
            <div style="display: flex; align-items: center; justify-content: space-between; padding: 0 0px; cursor: pointer;" (click)="toggleCategory(cat.link)">
              <p style="margin-bottom: 0;" [ngClass]="{'actual': num_subcategoria === -1}">{{cat?.texto}}</p>
              <i class="fa" [ngClass]="{'fa-chevron-down': !openCategories[cat.link], 'fa-chevron-up': openCategories[cat.link]}" style="transition: transform 0.3s ease;"></i>
            </div>
            <div class="collapse-content" [ngClass]="{'open': openCategories[cat.link]}">
              <p style="cursor: pointer; margin-left: 10px;" *ngFor="let element of cat.listado_subcategorias; let $index = index" [ngClass]="{'actual': num_subcategoria === $index}" routerLink="{{'/' + element?.link}}" (click)="num_subcategoria = $index">
                <input type="radio" name="subcategory" [checked]="num_subcategoria === $index" style="margin-right: 5px;">
                {{element?.texto}}
              </p>
              <p class="ver-todo-link" style="cursor: pointer; margin-left: 10px;" [ngClass]="{'actual': num_subcategoria === -1}" routerLink="{{'/' + cat?.link}}" (click)="num_subcategoria = -1">
                Ver todo
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="containerSidebarCategorias">
        <div class="row filter__top">
          <p routerLink="/productos" style="cursor: pointer;">Ver todas las categorías</p>
        </div>
      </div>
    </div>

    <div class="col-lg-10 col-md-12 col-12">
      <div class="w-100 mb-3 banner-category" *ngIf="bannerFamiliaActual && clientOnlyRun">
        <img class="w-100 d-none d-md-block"  [src]="bannerFamiliaActual" [alt]="'Banner '+familiaActual+' Desktop'" title="Sina">
        <img class="w-100 d-block d-md-none"  [src]="bannerFamiliaActual" [alt]="'Banner '+familiaActual+' Mobile'" title="Sina">
      </div>

      <div class="col-md-12 col-lg-10 col-12" *ngIf="mensaje" style="
      display: flex;
      align-items: center;
      flex-direction: column;
      text-align: center;
      height: 300px;
      ">
        <p
        style="
          margin-top: 100px;
          margin-left: auto;
          margin-right: auto;
          font-size: 3em;
          color: var(--color-primario);
          opacity: 0.6;
        "
        >{{mensaje}}</p>
        <img title="Loading..." width="50" height="40" id="loadCat" *ngIf="mensaje === 'Cargando'" style="margin-left: auto; margin-right: auto;" [ngClass]="'lazyload'" data-src="./assets/images/loader/ajax-loader.gif"/>
      </div>

      <!-- Controles de filtros y ordenamiento para mobile/tablet -->
      <div class="d-block d-lg-none mb-3 d-flex justify-content-between align-items-center" *ngIf="mensaje !== 'Cargando' && listaResultados && listaResultados?.length">
        <!-- Botón de filtros a la izquierda -->
        <div>
          <button class="btn btn-no-border" (click)="toggleMobileFilters()" style="display: flex; align-items: center; gap: 8px;">
            <i class="fa fa-filter"></i>
            Filtros
          </button>
        </div>

        <!-- Ordenar productos a la derecha - COMENTADO TEMPORALMENTE -->
        <!--
        <div class="containerTopCategorias">
          <span style="font-weight: bold;">Ordenar productos:
            <div style="display: inline-block;">
              <button type="button" class="ordenProductos_selector fw-bold" (click)="toggleOrdenarMobile()">
                <p *ngIf="!ordenamiento || (!ordenamiento.startsWith('nombre') && !ordenamiento.startsWith('precio'))">Por defecto&nbsp;</p>
                <p *ngIf="ordenamiento && ordenamiento.startsWith('nombre')">Nombre&nbsp;</p>
                <p *ngIf="ordenamiento && ordenamiento.startsWith('precio') && loginStatus">Precio&nbsp;</p>
                <i *ngIf="!showOrdenarMobile" class="fa fa-chevron-down" aria-hidden="true" style="transition: transform 0.3s ease;"></i>
                <i *ngIf="showOrdenarMobile" class="fa fa-chevron-up" aria-hidden="true" style="transition: transform 0.3s ease;"></i>
              </button>
              <ul class="ordenProductos" *ngIf="showOrdenarMobile">
                <li (click)="ordenPorDefecto()" *ngIf="!ordenamiento || (!ordenamiento.startsWith('nombre') && !ordenamiento.startsWith('precio'))">
                  <p><strong>Por defecto</strong></p>
                  <p class="floatingRight"><strong><i class="fa fa-bullseye" aria-hidden="true"></i></strong></p>
                </li>
                <li (click)="ordenPorDefecto()" *ngIf="ordenamiento && (ordenamiento.startsWith('nombre') || ordenamiento.startsWith('precio'))" >
                  <p>Por defecto</p>
                  <p class="floatingRight"><i class="fa fa-circle" aria-hidden="true"></i></p>
                </li>
                <li (click)="ordenPorNombre()" *ngIf="ordenamiento && ordenamiento.startsWith('nombre')">
                  <p><strong>Nombre</strong></p>
                  <p class="floatingRight"><strong><i class="fa fa-bullseye" aria-hidden="true"></i></strong></p>
                </li>
                <li (click)="ordenPorNombre()" *ngIf="!ordenamiento || !ordenamiento.startsWith('nombre')">
                  <p>Nombre</p>
                  <p class="floatingRight"><i class="fa fa-circle" aria-hidden="true"></i></p>
                </li>
                <li (click)="ordenPorPrecio()" *ngIf="ordenamiento && ordenamiento.startsWith('precio') && loginStatus">
                  <p><strong>Precio</strong></p>
                  <p class="floatingRight"><strong><i class="fa fa-bullseye" aria-hidden="true"></i></strong></p>
                </li>
                <li (click)="ordenPorPrecio()" *ngIf="(!ordenamiento && loginStatus) || (!ordenamiento.startsWith('precio') && loginStatus)">
                  <p>Precio</p>
                  <p class="floatingRight"><i class="fa fa-circle" aria-hidden="true"></i></p>
                </li>
              </ul>
            </div>
          </span>
        </div>
        -->
      </div>
      <div class="row resultado" *ngIf="mensaje !== 'Cargando' && listaResultados && listaResultados?.length">
        <div class="resultado__item" *ngFor="let item of listaResultados | filter : term">
          <app-producto-item [item]="item" [sesion]="loginStatus" [mensaje]="_success" [mensajeFavorito]="_successFavorito"></app-producto-item>
        </div>
      </div>
      <br>
      <div class="row w-100" *ngIf="mensaje !== 'Cargando' && listaResultados && listaResultados?.length">
        <p class="iva__custom__border w-auto">{{iva_usuario}}</p>
        <p *ngIf="show_mensaje_ofertas" style="margin: 10px 0px;">Los productos que se encuentran en oferta, tienen una validez que se limita a la modalidad de contado efectivo, hasta agotar Stock.</p>
      </div>
      <div class="row" *ngIf="mensaje !== 'Cargando' && listaResultados && listaResultados?.length">
          <div class="siguiente" *ngIf="modoVista === 'Paginado'">
              <button (click)="paginado.anterior()">Anterior</button>
              <span>Página {{paginado.pagina}} de {{paginado.maximo}}</span>
              <button (click)="paginado.siguiente()">Siguiente</button>
          </div>
      </div>
    </div>
  </div>

  <!-- Panel lateral de filtros para mobile/tablet -->
  <div class="mobile-filters-overlay" *ngIf="showMobileFilters" (click)="closeMobileFilters()"></div>
  <div class="mobile-filters-panel" [ngClass]="{'open': showMobileFilters}">
    <div class="mobile-filters-header">
      <h5>Filtros</h5>
      <button class="btn-close" (click)="closeMobileFilters()">
        <i class="fa fa-times"></i>
      </button>
    </div>
    <div class="mobile-filters-content">
      <!-- Reutilizar el mismo sidebar que en desktop -->
      <div class="containerSidebarCategorias">
        <div class="filter__top vista" style="display: flex; align-items: center; justify-content: space-between;">
          <p style="margin-bottom: 0;">Vista</p>
          <i (click)="toggleVistaSidebar()" class="fa" [ngClass]="{'fa-chevron-down': !showVistaSidebar, 'fa-chevron-up': showVistaSidebar}" style="cursor: pointer; transition: transform 0.3s ease;"></i>
        </div>
        <div class="row listadoCategorias collapse-content" [ngClass]="{'open': showVistaSidebar}">
          <p *ngIf="modoVista === 'Listado'" style="margin-left: 20px; cursor: pointer;" (click)="cambiarVista('Listado')"><strong>Ver todos</strong></p>
          <p *ngIf="modoVista !== 'Listado'" style="margin-left: 20px; cursor: pointer;" (click)="cambiarVista('Listado')">Ver todos</p>
          <p *ngIf="modoVista === 'Paginado'" style="margin-left: 20px; cursor: pointer;" (click)="cambiarVista('Paginado')"><strong>Paginado</strong></p>
          <p *ngIf="modoVista !== 'Paginado'" style="margin-left: 20px; cursor: pointer;" (click)="cambiarVista('Paginado')">Paginado</p>
        </div>
      </div>
      <div class="containerSidebarCategorias">
        <div class="filter__top" style="display: flex; align-items: center; justify-content: space-between;">
          <p style="margin-bottom: 0;">Ordenar productos</p>
          <i (click)="toggleOrdenarSidebar()" class="fa" [ngClass]="{'fa-chevron-down': !showOrdenarSidebar, 'fa-chevron-up': showOrdenarSidebar}" style="cursor: pointer; transition: transform 0.3s ease;"></i>
        </div>
        <div class="row listadoCategorias collapse-content" [ngClass]="{'open': showOrdenarSidebar}">
          <p *ngIf="!ordenamiento || (!ordenamiento.startsWith('nombre') && !ordenamiento.startsWith('precio'))" style="margin-left: 20px; cursor: pointer;" (click)="ordenPorDefecto()"><strong>Por defecto</strong></p>
          <p *ngIf="ordenamiento && (ordenamiento.startsWith('nombre') || ordenamiento.startsWith('precio'))" style="margin-left: 20px; cursor: pointer;" (click)="ordenPorDefecto()">Por defecto</p>
          <p *ngIf="ordenamiento && ordenamiento.startsWith('nombre')" style="margin-left: 20px; cursor: pointer;" (click)="ordenPorNombre()"><strong>Nombre</strong></p>
          <p *ngIf="!ordenamiento || !ordenamiento.startsWith('nombre')" style="margin-left: 20px; cursor: pointer;" (click)="ordenPorNombre()">Nombre</p>
          <p *ngIf="ordenamiento && ordenamiento.startsWith('precio') && loginStatus" style="margin-left: 20px; cursor: pointer;" (click)="ordenPorPrecio()"><strong>Precio</strong></p>
          <p *ngIf="(!ordenamiento && loginStatus) || (!ordenamiento.startsWith('precio') && loginStatus)" style="margin-left: 20px; cursor: pointer;" (click)="ordenPorPrecio()">Precio</p>
        </div>
      </div>
      <div class="containerSidebarCategorias">
        <div class="filter__top" style="display: flex; align-items: center; justify-content: space-between;">
          <p style="margin-bottom: 0;">Categorias</p>
          <i (click)="toggleCategoriasSidebar()" class="fa" [ngClass]="{'fa-chevron-down': !showCategoriasSidebar, 'fa-chevron-up': showCategoriasSidebar}" style="cursor: pointer; transition: transform 0.3s ease;"></i>
        </div>
        <div class="listadoCategorias collapse-content" [ngClass]="{'open': showCategoriasSidebar}">
          <div class="listadoCategorias" *ngFor="let cat of id_categoria">
            <div style="display: flex; align-items: center; justify-content: space-between; padding: 0 0px; cursor: pointer;" (click)="toggleCategory(cat.link)">
              <p style="margin-bottom: 0;" [ngClass]="{'actual': num_subcategoria === -1}">{{cat?.texto}}</p>
              <i class="fa" [ngClass]="{'fa-chevron-down': !openCategories[cat.link], 'fa-chevron-up': openCategories[cat.link]}" style="transition: transform 0.3s ease;"></i>
            </div>
            <div class="collapse-content" [ngClass]="{'open': openCategories[cat.link]}">
              <p style="cursor: pointer; margin-left: 10px;" *ngFor="let element of cat.listado_subcategorias; let $index = index" [ngClass]="{'actual': num_subcategoria === $index}" routerLink="{{'/' + element?.link}}" (click)="num_subcategoria = $index">
                <input type="radio" name="subcategory" [checked]="num_subcategoria === $index" style="margin-right: 5px;">
                {{element?.texto}}
              </p>
              <p class="ver-todo-link" style="cursor: pointer; margin-left: 10px;" [ngClass]="{'actual': num_subcategoria === -1}" routerLink="{{'/' + cat?.link}}" (click)="num_subcategoria = -1">
                Ver todo
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="containerSidebarCategorias">
        <div class="row filter__top">
          <p routerLink="/productos" style="cursor: pointer;">Ver todas las categorías</p>
        </div>
      </div>
    </div>
  </div>
</div>
